import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en } from './translations/en'
import { fr } from './translations/fr'
import { de } from './translations/de'
import { normalizeUiLanguage } from '@/utils/getLocale'

const initialLang = normalizeUiLanguage(
  typeof navigator !== 'undefined' ? navigator.language : 'en'
)

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  de: { translation: de },
}

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: initialLang,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'de'],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
  })
} else {
  i18n.addResourceBundle('en', 'translation', en, true, true)
  i18n.addResourceBundle('fr', 'translation', fr, true, true)
  i18n.addResourceBundle('de', 'translation', de, true, true)
}

if (import.meta.hot) {
  import.meta.hot.accept(
    ['./translations/fr', './translations/en', './translations/de'],
    (modules) => {
      const frModule = modules?.[0] as { fr: typeof fr } | undefined
      const enModule = modules?.[1] as { en: typeof en } | undefined
      const deModule = modules?.[2] as { de: typeof de } | undefined

      if (frModule?.fr) {
        i18n.addResourceBundle('fr', 'translation', frModule.fr, true, true)
      }
      if (enModule?.en) {
        i18n.addResourceBundle('en', 'translation', enModule.en, true, true)
      }
      if (deModule?.de) {
        i18n.addResourceBundle('de', 'translation', deModule.de, true, true)
      }
    }
  )
}

export default i18n
